import {graphql, useMutation} from 'react-relay';

import type {archiveUserMutation} from '../../graphql/__generated__/archiveUserMutation.graphql';

const mutation = graphql`
  mutation archiveUserMutation($input: ArchiveUserInput!) {
    archiveUser(input: $input) {
      clientMutationId
      user {
        __typename
        archived
      }
    }
  }
`;

function useArchiveUser(): [
  (userId: string, callback: () => void, onError?: (error: Error) => void) => void,
  boolean,
] {
  const [commit, isInFlight] = useMutation<archiveUserMutation>(mutation);

  return [
    (userId, callback, onError) => {
      commit({
        variables: {
          input: {
            userId,
          },
        },
        onCompleted() {
          callback();
        },
        onError(error) {
          console.error(error);
          onError?.(error);
        },
      });
    },
    isInFlight,
  ];
}

export default useArchiveUser;
